/**
 * yd-about-reveal.js
 * IntersectionObserver 驱动的入场动效。
 * 触发条件：元素带 [data-reveal]；可选 data-reveal-stagger（毫秒延迟）。
 * 兼容主题编辑器：监听 shopify:section:load，针对新加载的 section 内元素重新初始化。
 */
(function () {
  function init(scope) {
    scope = scope || document;
    const els = scope.querySelectorAll('[data-reveal]:not(.is-on):not(.yd-about-observed)');
    if (!els.length) return;

    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-on'));
      return;
    }

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = parseInt(el.dataset.revealStagger || '0', 10);
          setTimeout(function () { el.classList.add('is-on'); }, delay);
          io.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    els.forEach(function (el) {
      el.classList.add('yd-about-observed');
      io.observe(el);
      // failsafe：observer 万一漏触发，2.5 秒后强制显示
      setTimeout(function () {
        if (!el.classList.contains('is-on')) {
          el.classList.add('is-on');
          io.unobserve(el);
        }
      }, 2500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // 主题编辑器：section 重渲后对新 DOM 重新 init
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
